import { createAction } from "redux-act";

/**
 * Create the action
 */

export const descriptionUpdate = createAction(
    "NEW_HOMEWORK_DESCRIPTION_UPDATE"
);
export const noteUpdate = createAction("NEW_HOMEWORK_NOTE_UPDATE");
export const dateUpdate = createAction("NEW_HOMEWORK_DATE_UPDATE");
export const timeslotUpdate = createAction("NEW_HOMEWORK_TIMESLOT_UPDATE");
export const subjectUpdate = createAction("NEW_HOMEWORK_SUBJECT_UPDATE");
export const typeUpdate = createAction("NEW_HOMEWORK_TYPE_UPDATE");
export const markUpdate = createAction("NEW_HOMEWORK_MARK_UPDATE");
export const imageUpdate = createAction("NEW_HOMEWORK_IMAGE_UPDATE");
export const linkEventHomework = createAction("LINK_EVENT_HOMEWORK");
export const loadExistingHomework = createAction("NEW_HOMEWORK_LOAD_EXISTING");
export const directInputUpdate = createAction(
    "NEW_HOMEWORK_DIRECT_INPUT_UPDATE"
);
export const directInputSwitcherUpdate = createAction(
    "NEW_HOMEWORK_DIRECT_INPUT_SWITCHER_UPDATE"
);
export const resetHomework = createAction("NEW_HOMEWORK_RESET");
export const directlyCreateTaskUpdate = createAction(
    "NEW_HOMEWORK_DIRECTLY_CREATE_TASK_UPDATE"
);

export function homeworkDescription(description) {
    return descriptionUpdate({
        description
    });
}

export function homeworkNote(note) {
    return noteUpdate({
        note
    });
}

export function homeworkDate(date) {
    return dateUpdate({
        date
    });
}

export function homeworkTimeslot(timeslot) {
    return timeslotUpdate({
        timeslot
    });
}

export function homeworkSubject(subject) {
    return subjectUpdate({
        subject
    });
}

export function homeworkType(type) {
    return typeUpdate({
        type
    });
}

export function homeworkMark(mark) {
    return markUpdate({
        mark
    });
}

export function homeworkImage(image) {
    return imageUpdate({
        image
    });
}

export function linkEventToHomework(event) {
    return linkEventHomework({
        event
    });
}

export function homeworkLoadExisting(homework) {
    return loadExistingHomework({
        homework
    });
}

export function homeworkUpdateDirectInput(directInput) {
    return directInputUpdate({
        directInput
    });
}

export function homeworkUpdateDirectInputSwitcher(directInputSwitcher) {
    return directInputSwitcherUpdate({
        directInputSwitcher
    });
}

export function homeworkDirectlyCreateTask(value) {
    return directlyCreateTaskUpdate({ value });
}

export function homeworkReset() {
    return resetHomework();
}
